import React from "react";
import { observer } from "mobx-react";
import { injectIntl, intlShape } from "react-intl";

import Comment from "./Comment";

@observer
class Comments extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { comments, note, intl } = this.props;

    return (
      <div className="note-comments-container">
        {comments.map(this.renderComment)}
      </div>
    );
  }

  renderComment = comment => {
    const { note } = this.props;

    return <Comment comment={comment} note={note} key={comment.id} />;
  };
}

Comments.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(Comments);
